import { FeatureToggleClientService } from 'feature-toggle-client';
export const CloseScriptTab = 'close-script-tab';
export class CodeEditorFeatures {
    static isCloseScriptTabEnabled() {
        return FeatureToggleClientService.getInstance().isFeatureEnabled(CloseScriptTab);
    }
}
